<template>
    <div>
        <CustomSelect
            v-bind="$props"
            :itemComponent="component"
            :value="color"
            @input="handleColor"
            :options="colors"
        >
            <div slot="selectedLabel" class="selected-color">
                <span v-if="!value">Sélectionnez une couleur</span>
                <span class="color-pill" :style="{ backgroundColor: color.color }" />
                <span>{{ color.color }}</span>
            </div>
        </CustomSelect>
    </div>
</template>

<script>
import CustomSelect from './Select';

// basic material colors
const COLORS = [
    '#f44336',
    '#e91e63',
    '#9c27b0',
    '#673ab7',
    '#3f51b5',
    '#2196f3',
    '#03a9f4',
    '#00bcd4',
    '#009688',
    '#4caf50',
    '#8bc34a',
    '#cddc39',
    '#ffeb3b',
    '#ffc107',
    '#ff9800',
    '#ff5722',
    '#795548',
    '#9e9e9e',
    '#607d8b',
];

export default {
    props: {
        ...CustomSelect.props,
        value: {
            type: String,
        },
    },
    data() {
        return {
            component: () => import('./SelectItemColor'),
            colors: COLORS.map((c) => ({
                id: c,
                text: c,
                color: c,
            })),
            color: this.convertColor(),
        };
    },
    watch: {
        value() {
            this.color = this.convertColor();
        },
    },
    methods: {
        convertColor() {
            const color = this.value || '';
            return {
                id: color,
                color: color,
                text: color,
            };
        },
        handleColor(event) {
            this.$emit('input', event.color);
        },
    },
    components: {
        CustomSelect,
    },
};
</script>

<style lang="scss">
.dropdown-toggle {
    .selected-color {
        display: inline-block;

        span {
            vertical-align: middle;

            &.color-pill {
                border-radius: 50%;
                width: 18px;
                height: 18px;
                align-self: center;
                display: inline-block;
                margin-right: 9px;
            }
        }
    }
}
</style>
